module.exports = __webpack_public_path__ + "static/img/bofang.1597e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/bofang.png
// module id = +3Jh
// module chunks = 24